export const OPENING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE =
	'OPENING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE';
export const CLOSING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE =
	'CLOSING_CUSTOM_ATTRIBUTE_DEFINITION_DELETE';
export const REMOVING_CUSTOM_ATTRIBUTE_DEFINITION = 'REMOVING_CUSTOM_ATTRIBUTE_DEFINITION';
export const REMOVED_CUSTOM_ATTRIBUTE_DEFINITION_SUCCESS =
	'REMOVED_CUSTOM_ATTRIBUTE_DEFINITION_SUCCESS';
export const REMOVED_CUSTOM_ATTRIBUTE_DEFINITION_FAILED =
	'REMOVED_CUSTOM_ATTRIBUTE_DEFINITION_FAILED';
export const CLEAN_CUSTOM_ATTRIBUTE_DEFINITIONS = 'CLEAN_CUSTOM_ATTRIBUTE_DEFINITIONS';
export const GET_CUSTOM_ATTRIBUTE_DEFINITIONS = 'GET_CUSTOM_ATTRIBUTE_DEFINITIONS';
export const RESET_CAD_LIST_DATA = 'RESET_CAD_LIST_DATA';
export const SET_CAD_LIST_BEGIN_LOADING = 'SET_CAD_LIST_BEGIN_LOADING';
export const SET_CAD_LIST_DATA = 'SET_CAD_LIST_DATA';
export const SET_CAD_LIST_STOP_LOADING = 'SET_CAD_LIST_STOP_LOADING';

export const DATA_FEATURES = {
	ADD: 'custom_attribute.add',
	EDIT: 'custom_attribute.edit',
	VIEW: 'custom_attribute.view',
};

export const LOCAL_STORAGE_CAD_DISPLAY_MODE = 'cad-display-mode';
export const CAD_LIST_ROW_LARGE_HEIGHT = 182;

export const STATE_KEY = 'cad-list';
